import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase-config";
import { collection, getDocs, where, query, orderBy, updateDoc, doc } from "firebase/firestore";
import loginBg from '../assets/svg/login.svg';
import "./EmployeeDashboard.css";
import { AbsencePopup } from "./EmployeeAbsenceList";

function AbsenceNotificationBlock({ absenceNotifications, onConsulterAbsence }) {
  if (!absenceNotifications || absenceNotifications.length === 0) return null;

  return (
    <div style={{ marginBottom: 18 }}>
      <div style={{
        background: '#fffde7', borderRadius: 10, padding: 16, marginBottom: 12,
        boxShadow: '0 2px 8px #ffe08255', border: '1px solid #ffe082',
        display: 'flex', flexDirection: 'column', alignItems: 'flex-start'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
          <span style={{ fontSize: 20 }}>✉️</span>
          <span style={{ fontWeight: 600, fontSize: 17 }}>Notification d'absence</span>
        </div>
        {absenceNotifications.map((notif) => (
          <div key={notif.id} style={{ fontSize: 13, color: '#444', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 10 }}>
            Notification de retour de demande d'absence
            <button style={{
              marginLeft: 8, fontSize: 13, background: '#ffeb3b', color: '#333',
              border: 'none', borderRadius: 8, padding: '2px 12px', fontWeight: 600, cursor: 'pointer'
            }} onClick={async () => await onConsulterAbsence(notif.id)}>Consulter</button>
          </div>
        ))}
      </div>
    </div>
  );
}

function EmployeeDashboardBoard() {
  const navigate = useNavigate();
  const [employeeName, setEmployeeName] = useState("");
  const [notifications, setNotifications] = useState([]);
  const [showAbsencePopup, setShowAbsencePopup] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (!user) return;
      try {
        const snap = await getDocs(query(
          collection(db, "employees"),
          where("email", "==", user.email)
        ));
        if (!snap.empty) {
          const d = snap.docs[0].data();
          setEmployeeName(`${d.prenom} ${d.nom}`);
        }
      } catch (e) {
        console.error("Erreur chargement profil:", e);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchNotif = async () => {
      const user = auth.currentUser;
      if (!user) return;
      try {
        const snap = await getDocs(query(
          collection(db, "absences"),
          where("employeeEmail", "==", user.email),
          where("vuParEmploye", "==", false),
          where("status", "in", ["Validé", "Refusé"]),
          orderBy("createdAt", "desc")
        ));
        setNotifications(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      } catch (e) {
        console.error("Erreur notifications:", e);
      }
    };
    fetchNotif();
  }, []);

  const handleConsulterAbsence = async (id) => {
    await updateDoc(doc(db, "absences", id), { vuParEmploye: true });
    setNotifications(prev => prev.filter(n => n.id !== id));
    setShowAbsencePopup(id);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: `url(${loginBg}) center/cover no-repeat`,
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.85)', borderRadius: 20, padding: 32,
        boxShadow: '0 8px 32px rgba(0,0,0,0.10)', minWidth: 320, maxWidth: 400,
        width: '90%', textAlign: 'center', display: 'flex', flexDirection: 'column',
        alignItems: 'center'
      }}>
        <h2 style={{ marginBottom: 8 }}>Tableau de bord</h2>
        {employeeName && (
          <div style={{ fontSize: 16, color: '#555', marginBottom: 24 }}>{employeeName}</div>
        )}

        <div style={{ marginBottom: 24, width: '100%' }}>
          <AbsenceNotificationBlock
            absenceNotifications={notifications}
            onConsulterAbsence={handleConsulterAbsence}
          />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%' }}>
          <button className="history" onClick={() => navigate("/history")}>Historique de travail</button>
          <button className="history" onClick={() => navigate("/absence-request")}>Demande d'Absence</button>
          <button className="payslip" onClick={() => navigate("/payslips")}>Bulletins de Paie</button>
          <button className="dashboard-back" onClick={() => navigate("/")}>Retour</button>
        </div>

        {showAbsencePopup && (
          <AbsencePopup id={showAbsencePopup} onClose={() => setShowAbsencePopup(null)} />
        )}
      </div>
    </div>
  );
}

export default EmployeeDashboardBoard;
